import React from 'react';

import { useProductWizardContext } from 'pages/menu/components/product-wizard';
import { ProductWizardStep } from 'pages/menu/components/product-wizard/types';
import { useProductWizardFlow } from 'pages/menu/components/product-wizard/use-product-wizard-flow';

import { ComboSlotType } from '../../product-customization/types';
import { ProductDetailBackArrow } from '../product-detail-back-arrow';
import { ProductDetailClose } from '../product-detail-close';

import {
  Container,
  ProductDetailFlowHeaderContainer,
  ProductTitle,
  getBackgroundColorByStep,
} from './styled';

interface IProductDetailHeader {
  comboSlotType?: ComboSlotType;

  /**
   * Used to be optional and had logic to figure out the title based on context, now each component is responsible for passing the title
   * You can figure out which title to pass by looking at the previous implementation here:
   * src/components/product-detail-v2/product-detail-flow/product-detail-header/use-product-detail-header.ts
   * TODO: remove this comment after all components have been updated
   */
  title: string;
}

export const ProductDetailHeader: React.FC<IProductDetailHeader> = ({ title }) => {
  const { currentFlowStep, cartIdEditing, goToPreviousStep } = useProductWizardFlow();
  const { setShowCloseDialog } = useProductWizardContext();

  const showCloseButton = currentFlowStep.step !== ProductWizardStep.ProductCustomization;
  const showBackArrow = currentFlowStep.step !== ProductWizardStep.ProductHome;

  const handleClose = () => {
    if (currentFlowStep.step === ProductWizardStep.ProductHome || cartIdEditing) {
      return goToPreviousStep();
    }
    setShowCloseDialog(true);
  };

  return (
    <ProductDetailFlowHeaderContainer
      testID="product-detail-flow-header"
      backgroundColor={getBackgroundColorByStep(currentFlowStep.step)}
    >
      <Container>
        {showBackArrow && <ProductDetailBackArrow onPress={goToPreviousStep} />}
        {showCloseButton && <ProductDetailClose onDismiss={handleClose} />}
        <ProductTitle>{title}</ProductTitle>
      </Container>
    </ProductDetailFlowHeaderContainer>
  );
};
